// v2/components/Skeleton.js — yukleniyor iskeletleri
import React from 'react';
import styles from './Skeleton.module.css';

/** Tek satir/kutu iskeleti. w ve h: sayi (px) veya string ('60%') */
export function Skel({ w = '100%', h = 11, r, shape = 'line', style, className = '' }) {
  const shapeCls = shape === 'circle' ? styles.circle : shape === 'box' ? styles.box : styles.line;
  return (
    <span
      className={`${styles.base} ${shapeCls} ${className}`}
      style={{
        width: typeof w === 'number' ? `${w}px` : w,
        height: typeof h === 'number' ? `${h}px` : h,
        borderRadius: r,
        ...style,
      }}
      aria-hidden="true"
    />
  );
}

/** Ust uste birkac satir */
export function SkelStack({ lines = 2, widths = [], gap = 5 }) {
  return (
    <span className={styles.stack} style={{ gap: `${gap}px` }}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skel key={i} w={widths[i] || (i === lines - 1 ? '62%' : '100%')} h={i === 0 ? 11 : 9} />
      ))}
    </span>
  );
}

/** Panel (kart) iskeleti */
export function SkelPanel({ rows = 3, head = true }) {
  return (
    <div className={styles.panelSkel} aria-hidden="true">
      {head && (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Skel w={3} h={16} r={2} />
          <Skel w={130} h={13} />
          <span style={{ marginLeft: 'auto' }}><Skel w={64} h={19} r={999} /></span>
        </span>
      )}
      {Array.from({ length: rows }).map((_, i) => (
        <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Skel w={38} h={38} shape="box" />
          <span style={{ flex: '1 1 auto' }}><SkelStack lines={2} widths={['72%', '46%']} /></span>
          <Skel w={70} h={15} />
        </span>
      ))}
    </div>
  );
}

export const skelStyles = styles;
export default Skel;
